import { SubscriptionEvent } from "./SubscriptionEvent";

export class SubscriptionRequest {
    public sourceId: string;
    public id: string;
    public emailAddress: string;
    public firstName: string;
    public lastName: string;
    public organization: string;
    public jobTitle: string;
    public uniqueName:string;
    public eventNames: string[]; 
    public subscribedEvents: SubscriptionEvent[]; 
    public unsubscribedEvents: SubscriptionEvent[]; 
}


 